import { Box, Grid } from '@material-ui/core';
import { Lender } from '@nemuru-eng/js-api-client';

import { LenderIcon } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';

import { useCustomTheme } from '../../../../../hooks/useCustomTheme';
import { ActionsOption } from '../../../../shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '../../../../shared/hooks/useDialog';
import { PendingDataWarning } from '../../../../shared/components/PendingDataWarning';
import { SubSectionWrapper } from '../../../../shared/components/SubSectionWrapper';
import { Text } from '../../../../shared/components/Text';
import { MerchantInLenderContextDialog } from './MerchantInLenderContextDialog';

interface LendersProps {
  merchantId: string;
  lenders?: Lender[];
  editModeAllowed?: boolean;
}

export const Lenders = ({ merchantId, lenders = [], editModeAllowed = false }: LendersProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const { opened, toggleDialog, setOpened } = useDialog();

  const toggleEditCredentialsDialog = editModeAllowed ? toggleDialog : undefined;

  const actions: ActionsOption[] | undefined = toggleEditCredentialsDialog
    ? [
        {
          display: (
            <Text tId={!lenders.length ? 'ADD_MERCHANT_IN_LENDER_CONTEXT' : 'EDIT_MERCHANT_IN_LENDER_CONTEXT'} />
          ),
          onClick: toggleEditCredentialsDialog,
          iconName: 'edit',
        },
      ]
    : undefined;

  return (
    <>
      <SubSectionWrapper title={'FINANCIAL_ENTITIES_ENABLED'} specificActionsOptionsArray={actions}>
        {!lenders.length ? (
          <PendingDataWarning />
        ) : (
          <Grid container spacing={2}>
            {lenders.map((lender) => (
              <Grid item key={lender.id}>
                <Box
                  p={3}
                  height={32}
                  width={32}
                  display={'flex'}
                  alignItems={'center'}
                  justifyContent={'center'}
                  bgcolor={palette.grey[50]}
                  borderRadius={customBorderRadius.paper}
                >
                  <LenderIcon lenderName={lender.name} style={{ maxHeight: 32, maxWidth: 32 }} />
                </Box>
              </Grid>
            ))}
          </Grid>
        )}
        <MerchantInLenderContextDialog
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          lenders={lenders}
          merchantId={merchantId}
        />
      </SubSectionWrapper>
    </>
  );
};
